import * as React from 'react';
import { Box, Card, Flex, Menu, Text, Tooltip, tabListBehavior, ProviderConsumer as FluentUIThemeConsumer } from "@fluentui/react-northstar";
import { withTranslation, WithTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { LoaderVisaoGeralAtendimentos } from "../../loaders/loaders";
import Data from "../../../constants/data";
import LineChart from "../../chart/charts/line";
import '../visao-geral-atendimentos/visao-geral-atendimentos.scss';

export interface IVisaoGeralAtendimentosState {
    activeTabId: number;
    metrics: any;
    chartData: any;
    loading: boolean;
}


interface IVisaoGeralAtendimentosProps extends WithTranslation {
    metrics: any;
    index: number;
    filter: any;
    customTitle?: string;
    collapseCharts: Function;
    collapsed: boolean;
    theme?: string;
}

class VisaoGeralAtendimentos extends React.Component<IVisaoGeralAtendimentosProps, IVisaoGeralAtendimentosState> {
    private localize: TFunction;

    constructor(props: IVisaoGeralAtendimentosProps) {
        super(props);
        this.localize = this.props.t;

        this.state = {
            activeTabId: 0,
            metrics: this.props.metrics,
            chartData: {
                labels: this.parseMetrics(this.props.metrics).label,
                datasets: [
                    {
                        label: this.localize("SolicitacoesAtendimento"),
                        data: this.parseMetrics(this.props.metrics).solicitacoesAtendimento,
                    },
                    {
                        label: this.localize("AtendimentosRealizados"),
                        data: this.parseMetrics(this.props.metrics).atendimentosRealizados,
                        backgroundColor: "#23B24D",
                    },
                ],
            },
            loading: false,
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.metrics !== this.props.metrics) {
            this.setState({
                activeTabId: this.props.index,
                chartData: {
                    labels: this.parseMetrics(this.props.metrics).label,
                    datasets: [
                        {
                            label: this.localize("SolicitacoesAtendimento"),
                            data: this.parseMetrics(this.props.metrics).solicitacoesAtendimento,
                        },
                        {
                            label: this.localize("AtendimentosRealizados"),
                            data: this.parseMetrics(this.props.metrics).atendimentosRealizados,
                            backgroundColor: "#23B24D",
                        },
                    ],
                },
            })
        }
    }

    public parseMetrics = (metricsData?: any) => {
        let metricsLabel: string[] = [];
        let solicitacoesAtendimento: number[] = [];
        let atendimentosRealizados: number[] = [];
        let totalSolicitacoesAtendimento: number[] = [];
        let totalAtendimentosRealizados: number[] = [];

        metricsData?.map((metric: any, index: number) => {
            let month = Data.monthNames[parseInt(metric.Day.substr(4, 2), 10) - 1];
            let day = metric.Day.substr(6, 2).replace(/^0+/, '');

            metricsLabel.push(month + " " + day);

            solicitacoesAtendimento.push(metric.SolicitacoesAtendimento);
            atendimentosRealizados.push(metric.AtendimentoRealizados);
            totalSolicitacoesAtendimento.push(metric.TotalSolicitacoesAtendimento);
            totalAtendimentosRealizados.push(metric.TotalAtendimentosRealizados);
        });

        return {
            label: metricsLabel,
            solicitacoesAtendimento: solicitacoesAtendimento,
            atendimentosRealizados: atendimentosRealizados,
            totalSolicitacoesAtendimento: totalSolicitacoesAtendimento,
            totalAtendimentosRealizados: totalAtendimentosRealizados,
        }
    }

    public setActiveTabId(index: number, item: any) {
        let selected = isNaN(item.content.split(" ")[0]) ? 0 : parseInt(item.content.split(" ")[0]);
        this.props.filter(selected, index).then((res: any) => this.setState({ loading: false }))

        this.setState({
            activeTabId: index
        })
    }

    public render() {
        return (
            <Box
                className="visao-geral-atendimentos"
                styles={{
                    display: "grid",
                    gridGap: ".5rem",
                    gridTemplate:
                        "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(30rem, 1fr))",
                    gridAutoFlow: "dense",
                    gridAutoRows: this.props.collapsed ? "15rem 2rem" : "23rem 2rem",
                    padding: ".5rem",
                    minWidth: "20rem",
                    "@media (max-width: 986px)": {
                        gridTemplate:
                            "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                    },
                }}
            >
                <Card.Header>
                    <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                        <Flex gap="gap.small" column styles={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                            <Tooltip
                                trigger={<Text truncated content={this.props.customTitle ? this.props.customTitle : this.localize("VisaoGeralAtendimentos")} style={{ margin: 0 }} weight="bold" />}
                                content={this.props.customTitle} />
                        </Flex>
                    </Flex>
                </Card.Header>
                <Card.Body
                    style={{
                        marginBottom: "0.75rem",
                        height: "100%",
                    }}
                    fitted
                >
                    <>
                        <Menu
                            hidden={this.props.collapsed}
                            className="tabList"
                            style={{
                                border: "none",
                                background: "none",
                                marginBottom: "1.25rem",
                            }}
                            items={[
                                {
                                    key: "7",
                                    content: this.localize("7dias")
                                },
                                {
                                    key: "30",
                                    content: this.localize("30dias")
                                },
                                {
                                    key: "60",
                                    content: this.localize("60dias")
                                }
                            ]}
                            activeIndex={this.props.index}
                            onItemClick={(currentTarget, props) => {
                                this.setState({ loading: true });
                                this.setActiveTabId(props && props.index ? props.index : 0, props);
                            }
                            }
                            accessibility={tabListBehavior}
                            underlined
                            primary
                        />

                        {this.state.loading ? <LoaderVisaoGeralAtendimentos /> :
                            <Flex
                                className="chartRelatorioAtendimentos"
                                column
                            >
                                <FluentUIThemeConsumer
                                    render={(globalTheme) => {
                                        return (
                                            <LineChart
                                                {...{
                                                    title: this.localize("RelatorioAtendimentos"),
                                                    data: this.state.chartData,
                                                    siteVariables: globalTheme.siteVariables,
                                                    collapsed: this.props.collapsed,
                                                    gradients: true,
                                                }}
                                            />
                                        )
                                    }}
                                />
                            </Flex>
                        }
                    </>
                </Card.Body>
            </Box>
        );
    }

}

const visaoGeralAtendimentosWithTranslation = withTranslation()(VisaoGeralAtendimentos);
export default visaoGeralAtendimentosWithTranslation;